import { memo } from 'react'
import PropTypes from 'prop-types'
import Icon from 'builder/components/Icon'
import ColorSelectButton from 'builder/components/ColorSelectButton'
import { useI18n } from 'builder/hooks/useI18n'
import { Container, ColorList, Color, DisabledColor, ActiveIcon, Tooltip } from './styles'

const ColorSelect = ({ onSelect, onAdd, options, selected, isNewBuilder, size = 32 }) => {
  const { i18n } = useI18n()

  const canAddColor = !!onAdd
  const isCustomSelected = !options.includes(selected)

  return (
    <Container>
      <ColorList $isNewBuilder={isNewBuilder}>
        {options.map((color, index) => (
          <Color
            size={size}
            key={color}
            color={color}
            selected={color === selected}
            id={`color-select-${index}`}
            onClick={() => onSelect(color)}
          >
            <ActiveIcon data-visible={color === selected} />
          </Color>
        ))}

        {canAddColor && options.length > 0 && (
          <ColorSelectButton
            color={selected}
            active={isCustomSelected}
            size={size}
            onClick={onAdd}
          />
        )}

        {options.length === 0 &&
          new Array(canAddColor ? 6 : 5).fill(0).map((color, index) =>
            index === 0 ? (
              <Color size={size} key={index} selected>
                <ActiveIcon />
              </Color>
            ) : (
              <DisabledColor $isNewBuilder={isNewBuilder} size={size} key={index}>
                {!isNewBuilder && <Tooltip>{i18n.t('builder.resume_editor.no_color')}</Tooltip>}
                <Icon.Lock />
              </DisabledColor>
            ),
          )}
      </ColorList>
    </Container>
  )
}

ColorSelect.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.any,
  onSelect: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  size: PropTypes.number,
  isNewBuilder: PropTypes.bool,
}

export default memo(ColorSelect)
